import classNames from 'classnames';
import * as React from 'react';

import { NavigationTrackerLink } from '../../../ReactComponents/NavigationTracker/NavigationTrackerLink';
import { HeaderLink } from '../../Header/HeaderLink.csharp';
import { HeaderLinkColor } from '../../Header/HeaderLinkColor.csharp';
import { HeaderLinkIcon } from '../../Header/HeaderLinkIcon.csharp';

interface NavigationLinksProps {
    firstSectionLinks: HeaderLink[];
    secondSectionLinks: HeaderLink[];
}

export const NavigationLinks = (props: NavigationLinksProps) => {
    const renderLinks = (links: HeaderLink[], trackNavigation: boolean) => {
        return links.map((link, i) => (
            <li key={i} className={classNames('NavigationLinks__Link', `NavigationLinks__Link--${HeaderLinkColor[link.color]}`)}>
                <NavigationTrackerLink href={link.link} source="Navigation" disableTracking={!trackNavigation}>
                    <span className={`NavigationLinks__LinkIcon SvgIcon NavigationLinkIcon--${HeaderLinkIcon[link.icon]}${HeaderLinkColor[link.color]}`} />
                    {link.text}
                </NavigationTrackerLink>
            </li>
        ));
    };

    return (
        <div className="NavigationLinks">
            {props.firstSectionLinks && <ul className="NavigationLinks__List">{renderLinks(props.firstSectionLinks, false)}</ul>}
            {props.secondSectionLinks && <ul className="NavigationLinks__List">{renderLinks(props.secondSectionLinks, true)}</ul>}
        </div>
    );
};
